import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AlertComponent } from '../common/alert/alert.component';
import { MsalService } from '@azure/msal-angular';
import { GlobalService } from './global.service';
import { GraphService } from './graph.service';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class GroupGuardService  {
  route: ActivatedRouteSnapshot;

  constructor(private readonly authService: MsalService, private readonly service: GraphService
    , private readonly router: Router
    , public globalServ: GlobalService
    , public globals: Globals) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.route = route;

    if (this.service.user.groupIDs.length > 0) {
      return this.validateGroup();
    }
    else {
      this.router.navigate(['/overage', { redirectPath: route.routeConfig.path }]);
    }
  }

  validateGroup(): boolean {
    const expectedGroups = this.route.data.expectedGroups;
    let matchGroups = expectedGroups.filter(grp => this.service.user.groupIDs.includes(grp));
    if (expectedGroups.length > 0 && matchGroups.length == 0) {
      this.globalServ.showAlertWithCallBack(AlertComponent, { success: false, message: "You do not have enough access. Redirecting to Home Page..." }
        , this.redirectOnUnAuthorizedAccess, this);
      return false;
    } else {
      return true;
    }
  }

  redirectOnUnAuthorizedAccess(thisRef: GroupGuardService) {
    window.location.href = thisRef.globals.config.platformHomeUrl;
  }
}
